<div>
    <div class="mb-4">
        <label for="cep" class="form-label required">CEP</label>
        <input type="text" class="form-control" name="cep" [(ngModel)]="endereco.cep"
            #cepModel="ngModel" #cepEl id="cep" required placeholder="Digite aqui" mask="00.000-000" (ngModelChange)="onSelectCep($event)"/>
        <abp-validation-summary [control]="cepModel" [controlEl]="cepEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="logradouro" class="form-label required">Logradouro</label>
        <input [disabled]="desabilitarCampoLogradouro" type="text" class="form-control" name="logradouro" [(ngModel)]="endereco.logradouro"
            #logradouroModel="ngModel" #logradouroEl id="logradouro" required placeholder="Digite aqui" maxlength="150"/>
        <abp-validation-summary [control]="logradouroModel" [controlEl]="logradouroEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="cidade" class="form-label required">Bairro</label>
        <input [disabled]="desabilitarCampoBairro" type="text" class="form-control" name="bairro" [(ngModel)]="endereco.bairro"
            #bairroModel="ngModel" #bairroEl id="bairro" required placeholder="Digite aqui" maxlength="150"/>
        <abp-validation-summary [control]="bairroModel" [controlEl]="bairroEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="cidade" class="form-label required">Cidade</label>
        <input [disabled]="desabilitarCampoCidade" type="text" class="form-control" name="cidade" [(ngModel)]="endereco.cidade"
            #cidadeModel="ngModel" #cidadeEl id="cidade" required placeholder="Digite aqui" maxlength="150"/>
        <abp-validation-summary [control]="cidadeModel" [controlEl]="cidadeEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="estado" class="form-label required">Estado</label>
        <input [disabled]="desabilitarCampoEstado" type="text" class="form-control" name="estado" [(ngModel)]="endereco.estado"
            #estadoModel="ngModel" #estadoEl id="estado" required placeholder="Digite aqui" maxlength="2"/>
        <abp-validation-summary [control]="estadoModel" [controlEl]="estadoEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="complemento" class="form-label">Complemento</label>
        <input type="text" class="form-control" name="complemento" [(ngModel)]="endereco.complemento"
            #complementoModel="ngModel" #complementoEl id="complemento" placeholder="Digite aqui" maxlength="150"/>
        <abp-validation-summary [control]="complementoModel" [controlEl]="complementoEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="referencia" class="form-label">Referência</label>
        <input type="text" class="form-control" name="referencia" [(ngModel)]="endereco.referencia"
            #referenciaModel="ngModel" #referenciaEl id="referencia" placeholder="Digite aqui" maxlength="150"/>
        <abp-validation-summary [control]="referenciaModel" [controlEl]="referenciaEl"></abp-validation-summary>
    </div>
    <div class="mb-4">
        <label for="numero" class="form-label">Número</label>
        <input type="text" class="form-control" name="numero" [(ngModel)]="endereco.numero"
            #numeroModel="ngModel" #numeroEl id="numero" placeholder="Digite aqui" maxlength="10"/>
        <abp-validation-summary [control]="numeroModel" [controlEl]="numeroEl"></abp-validation-summary>
    </div>
</div>